import { useDispatch } from 'react-redux';
import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';
import { Document } from 'types';

import UploadDocumentModal from 'modules/documents/components/Modals/UploadDocumentModal';
import ReplaceDocumentModal from 'modules/_shared/components/Modals/ReplaceDocumentModal';
import DocumentsTable from 'modules/documents/components/DocumentsTable';
import { useGetTransactionsSectionPermissions } from 'modules/transactions/hooks/useGetTransactionsSectionPermissions';
import { setModal } from 'modules/_shared/redux/modalActions';
import { UploadDocumentModalProvider } from 'modules/documents/components/Modals/UploadDocumentModal/context/UploadDocumentModalContext';
import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';

const OperationDetailsDocumentsTab: FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const { isAdmin, isReadOnly } = useGetTransactionsSectionPermissions().data;

  const { data, actions } = useOperationDetailsPage();

  const handleUploadDocument = () => {
    dispatch(
      setModal(
        <UploadDocumentModalProvider
          operation={data.operation}
          onUploadDocument={actions.fetchDocuments}
        >
          <UploadDocumentModal />
        </UploadDocumentModalProvider>
      )
    );
  };

  const handleReplaceDocument = (document: Document) => {
    dispatch(
      setModal(
        <ReplaceDocumentModal
          document={document}
          fetchDocuments={actions.fetchDocuments}
        />
      )
    );
  };

  return (
    <>
      <div className="nk-block-head">
        <div className="nk-block-head-content">
          {isAdmin && (
            <div className="d-flex justify-content-end mt-2">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUploadDocument}
                disabled={isReadOnly}
              >
                <em className="icon ni ni-upload mr-1" />
                {t('UpDocument')}
              </button>
            </div>
          )}
        </div>
      </div>

      <DocumentsTable
        documents={data.documents}
        handleReplaceDocument={handleReplaceDocument}
      />
    </>
  );
};

export default OperationDetailsDocumentsTab;
